module.exports = __webpack_public_path__ + "static/008580-34cd0477db9078c5055e0b7c2652b67d.jpg";